// extracted by mini-css-extract-plugin
export default {"formContainer":"NicknameForm_formContainer__IqjFA","input":"NicknameForm_input__8vimP","button":"NicknameForm_button__sPUUE"};